import React, { useState } from 'react';
import Layout from "../components/App/Layout";
import Navbar from "../components/App/Navbar";
import PageBanner from '../components/Common/PageBanner';
import Footer from "../components/App/Footer";
import SEO from "../components/App/SEO";

import ai_image from '../assets/images/ai_image.jpg';
import ai_banner2 from '../assets/images/ai-banner2.jpg';
import ai_banner3 from '../assets/images/ai_banner3.jpg';
import iot_1 from '../assets/images/iot_1.jpg';
import iot_2 from '../assets/images/iot_2.jpg';
import iot_3 from '../assets/images/iot_3.jpg';

import Custom_aps from '../assets/images/Custom_aps.png';
import data_preparation from '../assets/images/data_preparation.png';
import Industry_pecific from '../assets/images/Industry_pecific.png';
import Integration from '../assets/images/Integration.png';
import Ongoing_support from '../assets/images/Ongoing_support.png';
import Text_image from '../assets/images/Text_image.png';

// Add these imports at the top with other image imports
import step1_icon from '../assets/images/step1.png';
import step2_icon from '../assets/images/step2.png';
import step3_icon from '../assets/images/step3.png';
import step4_icon from '../assets/images/step4.png';
import step5_icon from '../assets/images/step5.png';

import Agriculture from '../assets/images/Agriculture.png';
import Automotive from '../assets/images/Automotive.png';
import Education from '../assets/images/Education.png';
import Energy from '../assets/images/Energy.png';
import Finance from '../assets/images/Finance.png';
import Government_public_sector from '../assets/images/Government_public_sector.png';
import Healthcare from '../assets/images/Healthcare.png';
import Legal_compliance from '../assets/images/Legal_compliance.png';
import Logistics from '../assets/images/Logistics.png';
import Manufacturing from '../assets/images/Manufacturing.png';
import Media from '../assets/images/Media.png';
import Retail from '../assets/images/Retail.png';
import Swal from 'sweetalert2';
import consistent from '../assets/images/consistent.png';
import phonecall from '../assets/images/phonecall.png';
import FunfactComponent from "../components/DynamicPages/FunfactComponent"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
const sendEmail = async (e) => {
  e.preventDefault()
  // alert('sent successfully');

  const messageBody = `

  Hi,
  
  Name: ${e.target.elements.name.value}
  Phone No: ${e.target.elements.email.value}
  Message: ${e.target.elements.message.value}
  technology:${e.target.elements.technology.value}
  `
  console.log(messageBody);
  try {

    const response = await fetch('https://p8t29dandg.execute-api.ap-south-1.amazonaws.com/prod', {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "no-cors", // no-cors, cors, *same-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: e.target.elements.email.value, messageBody },), // body data type must match "Content-Type" header
    }).then(() => Swal.fire(
      'Mail Sent Successfully!',

    )
    )
    window.location.reload(false);
    ;
    // const json = await response.json()

  } catch (error) {
    console.log(error);
  }
}
const services = [
  {
    title: "Custom AI-powered solutions",
    text: "Hire top Generative AI experts from SrashtaSoft to build intelligent, scalable, and automated solutions tailored to your business needs.",
    icon: Custom_aps,
  },
  {
    title: "Text, Image, Video, & Code Generation",
    text: "Our AI developers create powerful generative solutions that can produce text, images, videos, and even code with precision. Using GPT-4, DeepSeek, Gimini, Grok, Gum loop & other cutting-edge models.",
    icon: Text_image,
  },
  {
    title: "Industry-Specific Model Development",
    text: "We deliver AI models tailored specifically to your industry needs — be it healthcare, real estate, e-commerce, fintech, or education.",
    icon: Industry_pecific,
  },
  {
    title: "Integration & Automation Support",
    text: "Integrate powerful generative AI models seamlessly into your existing systems with help from our experienced team.",
    icon: Integration,
  },
  {
    title: "Data Preparation & Synthetic Data Generation",
    text: "High-quality data is the foundation of great AI. We help you analyze, clean, and structure your datasets for better AI training.",
    icon: data_preparation,
  },
  {
    title: "Ongoing Support & Optimization",
    text: "Our work doesn’t stop after deployment. We provide continuous monitoring, optimization, and support.",
    icon: Ongoing_support,
  },
];

const industries = [
  {
    title: "Finance",
    icon: Finance,
  },
  {
    title: "Manufacturing",
    icon: Manufacturing,
  },
  {
    title: "Media & Entertainment",
    icon: Media,
  },
  {
    title: "Retail & E-Commerce",
    icon: Retail,
  },
  {
    title: "Energy & Utilities",
    icon: Energy,
  },
  {
    title: "Legal & Compliance",
    icon: Legal_compliance,
  },
  {
    title: "Automotive",
    icon: Automotive,
  },
  {
    title: "Healthcare",
    icon: Healthcare,
  },
  {
    title: "Agriculture",
    icon: Agriculture,
  },
  {
    title: "Logistics & Supply Chain",
    icon: Logistics,
  },
  {
    title: "Education",
    icon: Education,
  },
  {
    title: "Government & Public Sector",
    icon: Government_public_sector,
  },

];

// Update the executionSteps array to include icons
const executionSteps = [
  { text: "Project Initiation & Requirements", icon: step1_icon },
  { text: "Solution Design", icon: step2_icon },
  { text: "Development & Training", icon: step3_icon },
  { text: "Testing & QA", icon: step4_icon },
  { text: "Deployment & Support", icon: step5_icon }
];

const faqData = [
  {
    question: 'What AI development services do you offer?',
    answer: 'We offer services like natural language processing, machine learning model development, computer vision, AI consulting, and custom AI solution development.',
  },
  {
    question: 'How can AI benefit my business?',
    answer: 'AI can streamline operations, improve customer service, provide predictive analytics, and automate routine tasks, increasing overall efficiency and innovation.',
  },
  {
    question: 'What industries do you specialize in?',
    answer: 'We specialize in healthcare, finance, e-commerce, manufacturing, and logistics, among other industries.',
  },
];


const IotDevelopment = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Layout>
      <SEO
        title="Generative AI Development Services | Hire LLM & AI Experts | SrashtaSoft"
        description="SrashtaSoft offers expert Generative AI development, LLM integration, and automation solutions. Hire top AI developers to build intelligent, scalable applications today."
        canonical="https://srashtasoft.com/generative-ai-development/"
        isServicePage
        serviceName="Generative AI Development Services"
        faqData={faqData}
      />
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section" style={{
        background: `url(${ai_image}) no-repeat center center/cover`,
        height: "500px",
        color: "white",
        display: "flex",
        alignItems: "center"
      }}>
        <div className="bg-overlay d-flex align-items-center w-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <h2 className="fw-bold">
                  Generative AI Development, LLM Integration, <br />and Gum loop Automation
                </h2>
                <p className="mt-3 text-white">
                  Generative AI empowers businesses with automation, personalization, & <br />
                  data-driven decision-making. By leveraging advanced AI models, companies can <br />
                  enhance content creation, streamline operations, & improve user engagement.
                </p>
                <a href="/contact-us/" className="btn btn-custom mt-4">Let’s talk Now!</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6">
              <h2 className="h1 fw-bold text-headings mb-4">
                Partner With a Leading Generative AI Development Company to Power Your Innovation
              </h2>
              <p className="text-secondary mb-3">
                A high-performance business strategy today demands smart, scalable AI solutions to deliver engaging experiences, automate operations, and unlock new growth.
              </p>
              <p className="text-secondary mb-4">
                Whether you're looking for standalone services such as AI consulting, model development, synthetic data generation, or integration with your existing apps — we’ve got you covered.
              </p>
              <a href="/contact-us" className="btn btn-white px-4 py-2" style={{
                color: "#1A2B5F",
                border: "0.6px solid #1A2B5F",
                textDecoration: "none" // optional, to remove underline
              }}>
                Let’s Talk About Your Requirements
              </a>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-6">
                  <img src={iot_1} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 1" />
                </div>
                <div className="col-6">
                  <img src={iot_2} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 2" />
                </div>
                <div className="col-12 pt-4">
                  <img src={iot_3} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Banner CTA */}
      <section className="py-5 text-white position-relative" style={{
        background: `url(${ai_banner2}) no-repeat center center/cover`,
        height: "350px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#007bff40",
          zIndex: 1
        }}></div>

        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start" style={{ position: "relative", zIndex: 2 }}>
          <h2 className="h3 fw-bold mb-4 mb-md-0" style={{ fontSize: "46px" }}>
            Looking to build on<br />AI product in the industry?<br />We’ve done it before
          </h2>
          <a href="/contact-us/" className="btn btn-light fw-semibold text-dark" style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "2%",
            width: "180PX",
            height: "56",
            borderRadius: "6px"
          }}>
            Let’s talk Now!
          </a>
        </div>
      </section>

      {/* Services */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-5 fw-bold text-center" style={{ color: "#1A2B5F", fontSize: "40px" }}>Generative AI Development</h2>
          <div className="row g-4">
            {services.map((service, index) => (
              <div className="col-md-6 col-lg-6" key={index} style={{ marginTop: "30px" }}>
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <img src={service.icon} loading="lazy" className="mb-3" alt={service.title} />
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text text-muted">{service.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h2 className="fw-bold mb-4" style={{ color: "#1A2B5F" }}>Industries We Serve</h2>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 g-4">
            {industries.map((industry, index) => (
              <div className="col" key={index} style={{
                height: "160px !important",
                marginTop: "24px"
              }}>
                <div className="p-4 shadow-sm h-100 text-center" style={{ borderRadius: "12px", border: "1px solid #E3E3E3" }}>
                  <img
                    src={industry.icon}
                    alt={industry.title}
                    className="mb-3"
                    loading="lazy"
                    style={{ width: "50px", height: "50px", objectFit: "contain" }}
                  />
                  <h5 className="fw-semibold font_size mb-2">{industry.title}</h5>
                  <p className="text-muted small mb-0">{industry.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Execution Steps */}
      <section className="bg-primary text-white py-5" style={{
        background: `url(${ai_banner3}) no-repeat center center/cover`,
        height: "660px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundBlendMode: "overlay"
      }}>
        <div className="container text-center" style={{ height: "663px", alignContent: "center" }}>
          <h2 className="fw-bold mb-5" style={{
            fontWeight: 700,
            fontSize: "40px",
            lineHeight: "40px",
            letterSpacing: "2%",
            textAlign: "center",
            textTransform: "capitalize"
          }} >How We Execute Your Project</h2>
          <div className="row justify-content-center gy-4" style={{ height: "313px" }}>
            {executionSteps.map((step, index) => (
              <div className="col-6 col-sm-4 col-md-2" key={index} style={index % 2 !== 0 ? { marginTop: "70px" } : {}}>
                <div className="d-flex flex-column align-items-center">
                  <img
                    src={step.icon}
                    alt={step.text}
                    className="mb-3"
                    style={{ width: "155px", height: "155px", objectFit: "contain" }}
                  />
                  <p className="fw-semibold small text-white mb-0" style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "4%",
                    textAlign: "center",
                    verticalAlign: "middle",
                    textTransform: "capitalize"
                  }}>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="text-center fw-bold mb-4"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textTransform: "capitalize",
            }}
          >
            FAQs: Artificial Intelligence (AI) Development Services
          </h2>

          <div className="panel-group wrap" id="bs-collapse">

            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is Generative AI, and how does it work?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Generative AI refers to artificial intelligence models that can create new content such as text, images, audio, or code. These models are trained on large datasets and use deep learning to understand patterns, enabling them to generate realistic and creative outputs based on prompts.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What are some real-world applications of Generative AI?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Generative AI is used in various industries to automate content creation, generate personalized marketing copy, design product visuals, write code, simulate customer responses in chatbots, and even compose music or video scripts—helping businesses save time and scale creativity.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How can Generative AI benefit my business?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Generative AI boosts productivity, reduces manual work, enhances customer experience through personalization, and opens new creative possibilities. It can generate marketing content, assist in product design, automate internal workflows, and improve data analysis with smart summaries.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Is Generative AI secure and reliable for enterprise use?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, when implemented correctly. We follow best practices for data privacy, model fine-tuning, and API integration. We also provide solutions with usage controls, audit trails, and role-based access to ensure enterprise-grade security and compliance.

                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How long does it take to implement a Generative AI solution?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Implementation time depends on the project’s scope and complexity. A basic integration can take 2–4 weeks, while a custom enterprise-grade solution may take 6–12 weeks, including discovery, prototyping, model training, and deployment.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
      <FunfactComponent />
      <section className='need-help-section' id='need-help'>
        <div className='container'>
          <div className='row quote-formss'>
            <div className='col-lg-6 col-md-12'>
              <h1>NEED HELP ?</h1>
              <p className='need-paragraph'>Choosing The Right Package</p>
              <div className='row padding-class'>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={consistent} />
                    </div>
                    <p className='normal-p'>	Contact a <strong class="yello-colors"> Generative AI WebDevelopment</strong></p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={phonecall} />
                    </div>
                    <p className='normal-p'>	<a classname="ancher-link" href="tel:+(91) 9898582705">Schedule <strong class="yello-colors"> a call with us  </strong></a></p>
                  </div>
                </div>

              </div>
              <span className='heading-text'>+(91) 9898582705</span>
            </div>
            <div className='col-lg-2 col-md-0'></div>
            <div className='col-lg-4 col-md-12'>
              <section id="quote" className="bg-msar msar-quote-form">
                <section className="row">
                  <form onSubmit={sendEmail}>

                    <div className="col-md-12">
                      <div className="mt-4 white-text">Get Your Free</div>
                      <h4 className='white-text'>Consultation &amp; Quote</h4>
                      <div id="frm-quote">
                        <div className="form-group mt-4">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Name*"
                            name="name"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Email*"
                            name="email"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <select class="form-control w-100 border-0 p-2 " name='technology'
                          //  onChange={onInputchange}
                          >
                            <option value="Service">Service Required </option>
                            <option value="ReactJs">ReactJs Development</option>
                            <option value="NodeJs">NodeJs Developement</option>
                            <option value="WordPress">WordPress Development</option>
                            <option value="PHP">PHP Development</option>
                            <option value="Laravel">Laravel Development</option>
                            <option value="Flutter">Flutter Development</option>
                            <option value="Reactnative">React Native Development</option>
                            <option value="Android">Android Development</option>
                            <option value="IOS">IOS Development</option>
                            <option value="graIOTpefruit">IOT Development</option>
                            <option value="UIUX">UI/UX Development</option>
                            <option value="Shopify">Shopify Development</option>
                            <option value="Magento">Magento Development</option>
                            <option value="Layout">Layout Design</option>
                            <option value="Html">Html Development</option>
                            <option value="Logo">Logo Design</option>
                            <option value="Python">Python Development</option>
                          </select>
                        </div>

                        <div className="form-group mb-0">
                          <textarea className="form-group w-100 border-0 p-2 mb-0"
                            rows="2"
                            placeholder="Your Text"
                            // onChange={onInputchange}
                            name="message"
                            required
                          >
                          </textarea>
                        </div>

                        <div className="mt-0 pt-0 small white-text">* Need to fill marked. Make a call more details required.</div>
                        <button type="submit" className="btn-white-custom btn btn-sm mt-3"> Send Message </button>
                      </div>
                    </div>
                  </form>
                </section>
              </section>
            </div>

          </div>
        </div>
      </section>


      <Footer />
    </Layout>
  );
};

export default IotDevelopment;
